import platformAccess from './platform-access';
import platformComponents from './platform-components';
import userData from './user-data';
import signupProviders from './signup-providers';

export default {
  platformAccess,
  platformComponents,
  userData,
  signupProviders,
};
